import React, { Component } from 'react';
import Heading from '../components/Heading';
import PasswordChange from '../components/Profile/PasswordChange';

export default class Password extends Component {
  render() {
    return (
      <div className="user">
        <Heading text="Change Password" />
        <PasswordChange />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Password.jsx